import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-page-title',
  templateUrl: './pagetitle.component.html',
  styleUrls: ['./pagetitle.component.scss']
})
export class PagetitleComponent implements OnInit {

  @Input() breadcrumbItems: Array<{}>;
  @Input() title: string;
  @Input() icon: string;
  @Input() path: string;
  @Input() pathText: string;

  constructor() { }

  ngOnInit() {
  }

}
